import React from "react";
import {
  TeamContainer,
  TeamMember,
  TeamMemberHeadshot,
  TeamWrapper,
} from "./styled";
import profilePlaceholder from "../../../assets/img/profile-placeholder.svg";

const Team = (props) => {
  // Define the desired order of team members
  const memberOrder = [
    "Ian Ashton",
    "Todd Jarrold",
    "Kirby Slocum",
    "Mindy Sedelmaier",
    "Angie Anderson",
    "Adrian Meli",
  ];

  // Sort members based on the predefined order
  const sortedMembers = [...props.members].sort((a, b) => {
    const aFullName = `${a.firstName} ${a.lastName}`;
    const bFullName = `${b.firstName} ${b.lastName}`;

    const aIndex = memberOrder.indexOf(aFullName);
    const bIndex = memberOrder.indexOf(bFullName);

    // If both names are in the order list, sort by their position
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }

    // If only one name is in the order list, prioritize it
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;

    // For names not in the order list, keep them at the end
    return 0;
  });

  return (
    <TeamWrapper id="nav-team">
      <div className="max-w-screen-xl mx-auto">
        <h2 className="pl-28 py-4 pt-4">Meet the Team</h2>
        <TeamContainer>
          {sortedMembers.map((member) => {
            const { firstName, lastName, account, title, nmlsNumber, mloPage } =
              member;
            let { headshot } = member;

            if (!headshot) {
              headshot = profilePlaceholder;
            }

            if (mloPage === true) {
              return (
                <TeamMember key={nmlsNumber}>
                  <TeamMemberHeadshot backgroundImage={headshot} />
                  <h3>{`${firstName} ${lastName}`}</h3>
                  <p>
                    <em>
                      {title}
                      <br />
                      {`NMLS# ${nmlsNumber}`}
                    </em>
                  </p>
                  <a
                    aria-label={`${firstName}'s site`}
                    href={`https://onetrusthomeloans.com/contact/${account}`}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Visit My Site
                  </a>
                </TeamMember>
              );
            }
            return null;
          })}
        </TeamContainer>
      </div>
    </TeamWrapper>
  );
};

export default Team;
